export interface ICommand { }

export class AddPersonCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.People.Commands.AddPersonCommandV1, TCh.Domain.RankHR'

	Id: string
	RegionId: string
	Email: string
	DisplayName: string
	CriteriaName: string
	ScaleName: string

	constructor (id: string, regionId: string, email: string, displayName: string, criteriaName: string, scaleName: string)
	{
		this.Id = id
		this.RegionId = regionId
		this.Email = email
		this.DisplayName = displayName
		this.CriteriaName = criteriaName
		this.ScaleName = scaleName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.People.Commands.AddPersonCommandV1, TCh.Domain.RankHR'
	}

}

export class CopyPersonVotesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.People.Commands.CopyPersonVotesCommandV1, TCh.Domain.RankHR'

	Id: string
	SourceVotingCycle: string
	DestVotingCycle: string

	constructor (id: string, sourceVotingCycle: string, destVotingCycle: string)
	{
		this.Id = id
		this.SourceVotingCycle = sourceVotingCycle
		this.DestVotingCycle = destVotingCycle
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.People.Commands.CopyPersonVotesCommandV1, TCh.Domain.RankHR'
	}

}

export class DisablePersonCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.People.Commands.DisablePersonCommandV1, TCh.Domain.RankHR'

	Id: string
	RegionId: string

	constructor (id: string, regionId: string)
	{
		this.Id = id
		this.RegionId = regionId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.People.Commands.DisablePersonCommandV1, TCh.Domain.RankHR'
	}

}

export class EnablePersonCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.People.Commands.EnablePersonCommandV1, TCh.Domain.RankHR'

	Id: string
	RegionId: string

	constructor (id: string, regionId: string)
	{
		this.Id = id
		this.RegionId = regionId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.People.Commands.EnablePersonCommandV1, TCh.Domain.RankHR'
	}

}

export class PersonVotedCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.People.Commands.PersonVotedCommandV1, TCh.Domain.RankHR'

	Id: string
	Votes: any

	constructor (id: string, votes: any)
	{
		this.Id = id
		this.Votes = votes
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.People.Commands.PersonVotedCommandV1, TCh.Domain.RankHR'
	}

}

export class UpdatePersonCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.RankHR.People.Commands.UpdatePersonCommandV1, TCh.Domain.RankHR'

	Id: string
	RegionId: string
	Email: string
	DisplayName: string
	CriteriaName: string
	ScaleName: string

	constructor (id: string, regionId: string, email: string, displayName: string, criteriaName: string, scaleName: string)
	{
		this.Id = id
		this.RegionId = regionId
		this.Email = email
		this.DisplayName = displayName
		this.CriteriaName = criteriaName
		this.ScaleName = scaleName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.RankHR.People.Commands.UpdatePersonCommandV1, TCh.Domain.RankHR'
	}

}

